import React, { useContext, useEffect } from "react"
import StateContext from "../StateContext"
import DispatchContext from "../DispatchContext"
import { useImmer } from "use-immer"

function Checkbox(props) {
	const appState = useContext(StateContext)
	const appDispatch = useContext(DispatchContext)
	const locked =
		appState.status[props.chapitreIdx].pauses[props.pauseIdx].contenus[props.contenuIdx].locked

	useEffect(() => {
		localStorage.setItem(
			`${appState.livre.isbn}-content-${props.chapitreIdx}-${props.pauseIdx}-${props.contenuIdx}-locked`,
			locked
		)
	}, [appState.lockCounter])

	function handleCheckboxClick(e) {
		e.preventDefault()
		appDispatch({
			type: "UPDATE_CONTENT_LOCK_STATUS",
			chapitreIdx: props.chapitreIdx,
			pauseIdx: props.pauseIdx,
			contenuIdx: props.contenuIdx,
		})
	}

	return (
		<button
			className={
				`btn btn-sm btn-checkbox ` + (locked ? "btn-checkbox--unchecked" : "btn-checkbox--checked")
			}
			onClick={(e) => handleCheckboxClick(e)}
		>
			<i className={"bi-check"}></i>
		</button>
	)
}

export default Checkbox
